export default "__VITE_ASSET__BXdJ9iRN__"